export const K1 = 'k1';
export const K2 = 'k2';
export const K3 = 'k3';
export const K4 = 'k4';
export const K5 = 'k5';
export const K6 = 'k6';
export const MAX_INVALID_PIN_ATTEMPTS = 'max_invalid_pin_attempts';
export const PHONE_UNBLOCK_SECONDS = 'phone_unblock_seconds';
export const PUBLICATION_PHOTO_SIZE_RANGE = 'publication_photo_size_range';
export const PUBLICATION_VIDEO_SIZE_RANGE = 'publication_video_size_range';
export const PUBLICATION_VIDEO_DURATION = 'publication_video_max_duration';
export const USER_AVATAR_SIZE_RANGE = 'user_avatar_size_range';
export const RADAR_DISTANCE_RANGE = 'radar_distance_range';
export const RADAR_DISTANCE_RANGE_METERS = 'radar_range_meters_range';
export const RADAR_DISTANCE_RANGE_FEET = 'radar_range_feet_range';
export const SMS_SENDING_TIMEOUT_SECONDS = 'sms_sending_timeout_seconds';
export const STORIES_DURATION = 'stories_duration';
export const STORIES_TTL = 'stories_ttl';
export const STORIES_VIDEO_MAX_FRAGMENTS = 'stories_video_max_fragments';
export const STORIES_PHOTO_DURATION = 'stories_photo_duration';
export const STORY_SIZE_RANGE = 'stories_size_range';
export const STORY_MAX_DURATION = 'stories_max_duration';
export const PUBLICATION_PHOTO_MAX_COUNT = 'publication_photo_max_count';
export const PUBLICATION_VIDEO_MAX_COUNT = 'publication_video_max_count';
export const PUBLICATION_INTEREST_MAX_COUNT = 'publication_interest_max_count';
export const CHAT_PHOTO_MAX_SIZE = 'chat_photo_max_size';
export const CHAT_VIDEO_MAX_SIZE = 'chat_video_max_size';
export const CHAT_MESSAGE_MAX_LENGTH = 'chat_message_max_length';
export const CHAT_MEDIA_MAX_COUNT = 'chat_media_max_count';
export const USER_PHONES_MAX_COUNT = 'user_phones_max_count';
export const USER_EMAILS_MAX_COUNT = 'user_emails_max_count';
export const CHAT_MAX_GROUP_PARTICIPANTS = 'chat_max_group_participants';
export const GIFT_NEAR_AVATAR_TTL = 'gift_near_avatar_ttl';
export const GIFTS_NEAR_AVATAR_ROTATE = 'gift_near_avatar_rotate';
export const GIFT_PHOTO_SIZE_RANGE = 'gift_photo_size_range';
export const JJ_FANS_VIDEO_SIZE_RANGE = 'jj_fans_video_size_range';
export const JJ_FANS_VIDEO_DURATION_RANGE = 'jj_fans_video_duration_range';
export const JJ_VIDEO_SIZE_RANGE = 'jj_video_size_range';
export const JJ_VIDEO_DURATION_RANGE = 'jj_video_duration_range';
export const PUBLICATION_JJFAN_VIEW_MIN_THRESHOLD = 'publication_jjfan_view_min_threshold';
export const PUBLICATION_VIDEO_VIEW_MIN_THRESHOLD = 'publication_video_view_min_threshold';
export const PUBLICATION_JJFAN_DESCRIPTION_LENGTH = 'publication_jjfan_description_max_length';

export const SETTINGS = {
  [K1]: { label: 'settings.k1' },
  [K2]: { label: 'settings.k2' },
  [K3]: { label: 'settings.k3' },
  [K4]: { label: 'settings.k4' },
  [K5]: { label: 'settings.k5' },
  [K6]: { label: 'settings.k6' },
  [MAX_INVALID_PIN_ATTEMPTS]: { label: 'settings.max_invalid_pin_attempts' },
  [PHONE_UNBLOCK_SECONDS]: { label: 'settings.phone_unblock_seconds' },
  [PUBLICATION_PHOTO_SIZE_RANGE]: { label: 'settings.publication_photo_size_range', range: true },
  [PUBLICATION_VIDEO_SIZE_RANGE]: { label: 'settings.publication_video_size_range', range: true },
  [PUBLICATION_VIDEO_DURATION]: { label: 'settings.publication_video_max_duration' },
  [JJ_FANS_VIDEO_SIZE_RANGE]: { label: 'settings.jj_fans_video_size_range', range: true },
  [JJ_FANS_VIDEO_DURATION_RANGE]: { label: 'settings.jj_fans_video_duration_range', range: true },
  [JJ_VIDEO_SIZE_RANGE]: { label: 'settings.jj_video_size_range', range: true },
  [JJ_VIDEO_DURATION_RANGE]: { label: 'settings.jj_video_duration_range', range: true },
  [PUBLICATION_JJFAN_VIEW_MIN_THRESHOLD]: { label: 'settings.publication_jjfan_view_min_threshold' },
  [PUBLICATION_VIDEO_VIEW_MIN_THRESHOLD]: { label: 'settings.publication_video_view_min_threshold' },
  [RADAR_DISTANCE_RANGE_METERS]: { label: 'settings.radar_distance_range_meters', range: true },
  [RADAR_DISTANCE_RANGE_FEET]: { label: 'settings.radar_distance_range_feet', range: true },
  [USER_AVATAR_SIZE_RANGE]: { label: 'settings.user_avatar_size_range', range: true },
  [CHAT_PHOTO_MAX_SIZE]: { label: 'settings.chat_photo_max_size' },
  [CHAT_VIDEO_MAX_SIZE]: { label: 'settings.chat_video_max_size' },
  [CHAT_MESSAGE_MAX_LENGTH]: { label: 'settings.chat_message_max_length' },
  [CHAT_MEDIA_MAX_COUNT]: { label: 'settings.chat_media_max_count' },
  [CHAT_MAX_GROUP_PARTICIPANTS]: { label: 'settings.chat_max_group_participants' },
  [SMS_SENDING_TIMEOUT_SECONDS]: { label: 'settings.sms_sending_timeout_seconds' },
  // [STORIES_DURATION]: { label: 'settings.stories_duration' },
  // [STORIES_TTL]: { label: 'settings.stories_ttl' },
  // [STORIES_VIDEO_MAX_FRAGMENTS]: { label: 'settings.stories_video_max_fragments' },
  [USER_PHONES_MAX_COUNT]: { label: 'settings.user_phones_max_count' },
  [USER_EMAILS_MAX_COUNT]: { label: 'settings.user_emails_max_count' },
  [PUBLICATION_PHOTO_MAX_COUNT]: { label: 'settings.publication_photo_max_count' },
  [PUBLICATION_VIDEO_MAX_COUNT]: { label: 'settings.publication_video_max_count' },
  [PUBLICATION_INTEREST_MAX_COUNT]: { label: 'settings.publication_interest_max_count' },
  [GIFT_NEAR_AVATAR_TTL]: { label: 'settings.gift_near_avatar_ttl' },
  [GIFTS_NEAR_AVATAR_ROTATE]: { label: 'settings.gift_near_avatar_rotate' },
  [GIFT_PHOTO_SIZE_RANGE]: { label: 'settings.gift_photo_size_range', range: true },
  [STORIES_PHOTO_DURATION]: { label: 'settings.stories_photo_duration' },
  [STORY_MAX_DURATION]: { label: 'settings.stories_max_duration' },
  [STORY_SIZE_RANGE]: { label: 'settings.story_size_range', range: true },
  [PUBLICATION_JJFAN_DESCRIPTION_LENGTH]: { label: 'settings.jj_fans_description_length' },
};
